var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
import { KtsTaskConditionService, TaskCondition } from './task-condition.service';
import { ItemBase } from '../../../../../models/item/item-base';
var KtsTaskLabelComponent = /** @class */ (function (_super) {
    __extends(KtsTaskLabelComponent, _super);
    function KtsTaskLabelComponent(service, baseService, taskCondService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.taskCondService = taskCondService;
        _this.cols = [];
        return _this;
    }
    KtsTaskLabelComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    KtsTaskLabelComponent.prototype.ngOnChanges = function (changes) {
        var key = this.col.key;
        var cols = new TaskCondition(key, this.msg).cols;
        this.cols = [];
        this.cols.push(cols[0]);
        this.cols[0].params.options = this.taskCondService.getStep(key);
        if (this.val[cols[1].key]) {
            this.cols.push(Object.assign(new ItemBase(), { controlType: 'label', label: ', ' }));
            this.cols.push(cols[1]);
            this.cols[2].params.options = this.taskCondService.getTask(key);
        }
        if (this.val[cols[3].key] || this.val[cols[5].key]) {
            this.cols.push(Object.assign(new ItemBase(), { controlType: 'label', label: ', ' }));
            this.cols.splice(this.cols.length, 0, cols[3], cols[4], cols[5]);
            this.cols[this.cols.length - 2].label = ' ~ ';
        }
        if (this.val[cols[7].key]) {
            this.cols.push(Object.assign(new ItemBase(), { controlType: 'label', label: ', ' }));
            this.cols.splice(this.cols.length, 0, cols[7]);
        }
    };
    KtsTaskLabelComponent.decorators = [
        { type: Component, args: [{
                    selector: 'kts-column-task-label',
                    template: '<ng-template ngFor let-c [ngForOf]="cols" let-idx="index"><column-formlabel [componentName]="componentName" [index]="index" [col]="c" [val]="val[c.key]" [msg]="msg"></column-formlabel></ng-template>'
                }] }
    ];
    /** @nocollapse */
    KtsTaskLabelComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: KtsTaskConditionService }
    ]; };
    return KtsTaskLabelComponent;
}(ColumnBaseComponent));
export { KtsTaskLabelComponent };
//# sourceMappingURL=task-label.component.js.map